<template>
    <Dropdown
        :triggers
        :placement
        :distance
        :skidding
        :no-auto-focus
        :auto-hide
        :popper-class="`ew-dropdown${expanded ? ' is-expanded' : ''}${paddingless ? ' is-paddingless' : ''}`"
        class="tw-cursor-pointer"
        @show="model = true"
        @hide="model = false"
    >
        <slot name="trigger" :open="model">
            <div class="default-trigger"><i class="mdi mdi-dots-vertical tw-text-lg"></i></div>
        </slot>
        <template #popper>
            <button ref="closePopper" v-close-popper type="button" class="tw-sr-only">Close</button>
            <slot />
        </template>
    </Dropdown>
</template>
<script setup>
import { Dropdown } from 'floating-vue';
import { useTemplateRef } from 'vue';

defineProps({
    triggers: {
        type: Array,
        default: () => ['click'],
    },
    placement: {
        type: String,
        default: 'bottom-start',
    },
    distance: {
        type: Number,
        default: 8,
    },
    skidding: {
        type: Number,
        default: 0,
    },
    noAutoFocus: {
        type: Boolean,
        default: false,
    },
    expanded: {
        type: Boolean,
        default: false,
    },
    paddingless: {
        type: Boolean,
        default: false,
    },
    autoHide: {
        type: Boolean,
        default: true,
    },
});

const model = defineModel({
    type: Boolean,
    default: false,
});

const closePopper = useTemplateRef('closePopper');

const close = () => {
    closePopper.value?.click();
};

defineExpose({
    close,
});
</script>
<style lang="scss">
.ew-dropdown {
    &.is-expanded {
        .v-popper__inner {
            width: unset;
            max-width: 600px !important;
        }
    }
    &.is-paddingless .v-popper__inner {
        padding: 0;
    }
    .v-popper__arrow-container {
        display: none;
    }
    ul {
        @apply tw-m-0 tw-flex tw-flex-col;
        li {
            &.separator {
                @apply tw-h-[1px] tw-bg-slate-200;
            }

            a,
            button {
                @apply tw-flex tw-gap-1 tw-py-1 tw-px-3 tw-w-full;

                &:has(i) {
                    @apply tw-pl-4;
                }
                & > i {
                    @apply tw-relative tw-block tw-left-[-3px] tw-top-[1px] tw-scale-110;
                }
                &:hover {
                    @apply tw-bg-slate-100;
                }
            }
        }
    }
}
</style>
